import React from 'react';
import InputMask from '@mona-health/react-input-mask';

import { TextField } from '@mui/material';

const useStyles = (): any => ({
  root: {
    maxWidth: 200,
    width: '100%',
    '& > .MuiFormHelperText-root': {
      textAlign: 'center',
    },
  },
});

export interface IFormValues {
  cpf: string;
}

type InputProps = {
  onBlur: () => void;
  onChange: (value: unknown) => void;
  errorMessage: string | undefined;
};

const CpfInput: React.FC<InputProps> = ({ onBlur, onChange, errorMessage }) => {
  const classes = useStyles();
  const matchesXs = '(min-width: 465px)';

  return (
    <InputMask onBlur={onBlur} onChange={onChange} mask="9999" alwaysShowMask>
      <TextField
        autoFocus
        error={!!errorMessage}
        helperText={errorMessage}
        inputProps={{
          style: {
            textAlign: 'center',
            fontSize: matchesXs ? '50px' : '35px',
          },
        }}
        sx={classes.root}
        variant="standard"
      />
    </InputMask>
  );
};

export default CpfInput;
